import React from 'react';
import { useYSPContext } from '@stories/Widgets/YourSolution/YS/Context/YSContext';
import { SharedStyles } from '@ys/Components/Shared.styles';
import { SolutionsStyles as S } from './Solutions.styles';
import { FormStyles } from '@ys/Components/Shared/Form.styles';
import { YSLinkButton } from '../../Shared/YSButton/YSButton';
const Solutions = () => {
    const { state } = useYSPContext();
    if (state.results === undefined) {
        return null;
    }
    return (React.createElement(SharedStyles.Question, null,
        React.createElement(FormStyles.Form, null,
            React.createElement(SharedStyles.CenterText, { dangerouslySetInnerHTML: { __html: state.results.responseMessage } })),
        React.createElement(S.Container, null, state.results.solutions.map((x) => (React.createElement(S.Item, { key: x.url },
            React.createElement(S.Copy, null,
                React.createElement(S.CopyInner, null,
                    React.createElement("h2", null, x.displayName),
                    React.createElement("ul", null, Object.keys(x.tableData).map((key) => (React.createElement("li", { key: key },
                        React.createElement("span", null,
                            React.createElement("strong", null, key),
                            x.tableData[key]))))),
                    React.createElement(YSLinkButton, { fill: "outline", target: "_blank", href: x.url }, "Download Solution"))),
            React.createElement(S.Media, null,
                React.createElement(S.MediaInner, null,
                    React.createElement("picture", null,
                        React.createElement("source", { media: "(min-width: 996px)", srcSet: x.desktopImage }),
                        React.createElement("img", { src: x.desktopImage, srcSet: x.mobileImage })))))))),
        state.authenticatedUser === undefined && (React.createElement(FormStyles.Form, null,
            React.createElement(SharedStyles.CenterText, null,
                React.createElement("div", { dangerouslySetInnerHTML: { __html: state.results.technicalMessage } }),
                React.createElement("br", null),
                React.createElement(YSLinkButton, { center: true, href: state.technicalLibraryUrl }, "Create an Account"))))));
};
export default Solutions;
